// Client-side shim for node:async_hooks (server-only API)
class AsyncLocalStorage {
  constructor() {
    this._store = undefined;
  }
  getStore() {
    return this._store;
  }
  enterWith(store) {
    this._store = store;
  }
  run(store, callback, ...args) {
    const prev = this._store;
    this._store = store;
    try {
      return callback(...args);
    } finally {
      this._store = prev;
    }
  }
}

module.exports = { AsyncLocalStorage };
